import { Link } from "react-router-dom";
import { useAuth } from "../../../contexts/AuthContext";
import Button from "../../ui/Button";
import styles from "./Header.module.scss";

const Header = () => {
  const { user, adminLogout } = useAuth();

  return (
    <div className={styles.header}>
      <div className={styles.logo}>
        <Link to="/admin" className={styles.header__link}>
          <img
            className={styles.logo__img}
            src="/common/assets/images/logo.png"
            alt="logo"
          ></img>
          <span className={styles.logo__appname}>管理画面</span>
        </Link>
      </div>

      <div className={styles.header__userinfo}>
        <span className={styles.header__username}>
          ようこそ
          <br></br>
          {user.name} 様
        </span>
        <Button onClick={adminLogout} styleType="logout">
          ログアウト
        </Button>
      </div>
    </div>
  );
};
export default Header;
